import { getScaleDisplayName, isScaleCompatibleWith, getScaleForSampleName, getTranspositionForScaleToMatchTonality, transposeScale } from "$utils/music"; // music theory related
import { Dropdown } from 'primereact/dropdown';
import { sampleLibrary} from "../sampleLibrary";
import { useDispatch, useSelector } from "react-redux";
import { selectTonality, setClipParameter } from "../store";
import { getSampleLibraryManagerInstance } from '../SamplePlayer';
import { getPadParameterName } from "../instruments/Sampler";

export const SelectorSonsLLibreria = ({selectedSoundName="", className, onChange, transpositionSemitones=0, ...props}) => {

    const tonalitat = useSelector(selectTonality);
    const sampleOriginalScale = getScaleForSampleName(selectedSoundName);
    let sampleScale = transposeScale(sampleOriginalScale, transpositionSemitones);
    const isTransposed = transpositionSemitones !== 0;
    
    const options = 
        [...sampleLibrary.sampler.map(item => {
            const { name, scale: originalScale } = item;
            const transposedScale = transposeScale(originalScale, transpositionSemitones);
            return {
            'label': name + ' (' + getScaleDisplayName(originalScale) + (isTransposed ? ` → ${getScaleDisplayName(transposedScale)}` : '') + ')', 
            'value': name,
            'scale_transposed': transposedScale,
        }})
    ];
    
    const optionTemplate = (option) => {
        const transposedScale = option.scale_transposed;
        let optionScaleCSSClass = "";
        if (!isScaleCompatibleWith(transposedScale, tonalitat)) optionScaleCSSClass = "text-red";
        return (
            <span className={optionScaleCSSClass}>{option.label}</span>
        );
    };

    let scaleCSSClass = "";
    if (!isScaleCompatibleWith(sampleScale, tonalitat)) scaleCSSClass = "text-red";
    if (sampleScale === undefined) scaleCSSClass = "text-orange";
    if (!selectedSoundName) scaleCSSClass = "";

    return (
        <Dropdown
            {...props}
            className= {`${scaleCSSClass} bg-black ${className}` }
            style={{ ...props.style, background: "var(--background-color )"}}
            itemTemplate={optionTemplate}
            value={selectedSoundName}
            onChange={(evt) => onChange(evt)}
            options={options}
            placeholder="Cap"
        />
    )
}

export const SelectorSonsSampler = ({instrument, parameterName, className, transposeSelector}) => {
    const selectedSoundName = useSelector(instrument.getDisplayParameterSelector(parameterName));
    const transpose = useSelector(transposeSelector);
    const tonality = useSelector(selectTonality);
    const dispatch = useDispatch();
    return <SelectorSonsLLibreria data-widget-id="sampleSelect" className={className} selectedSoundName={selectedSoundName} onChange={(evt) => {
        instrument.updateParametreInstrument(parameterName, evt.target.value);
        const originalScale = getScaleForSampleName(evt.target.value);
        const transposition = getTranspositionForScaleToMatchTonality(originalScale, tonality);
        Array(16).fill().map((_, i) => i).forEach(padIndex => {
            dispatch(instrument.getParameterHandler(getPadParameterName(padIndex, "transpose")).updater(transposition));
        })
        instrument.updateParameter
    }} transpositionSemitones={transpose} />
}

export const SelectorSonsLooper = ({instrument, ...props}) => {
    const currentClip = useSelector(instrument.getDisplayClipSelector());
    const {soundName} = currentClip.sound;
    const dispatch = useDispatch();    

    const transpose = useSelector(instrument.getDisplayParameterSelector("transpose"));
    const speed = useSelector(instrument.getDisplayParameterSelector("speed"));
    
    return <SelectorSonsLLibreria 
        data-widget-id="sampleSelect"
        selectedSoundName={soundName}
        transpositionSemitones={transpose} 
        {...props}
        onChange={(evt) => {
            dispatch(setClipParameter({instrumentID: instrument.id, parameter: "soundName", value: evt.target.value}));
            getSampleLibraryManagerInstance().getBufferForSound(evt.target.value, () => instrument.adjustClipLengthToFit())
        }} />
}